"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: subscription/merchant-link-status.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fsubscription%2Fmerchant-link-status.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.merchantLinkStatusToJSON = exports.merchantLinkStatusFromJSON = exports.MerchantLinkStatus = void 0;
/* eslint-disable */
const protobufPackage = 'com.step.subscription.proto';
var MerchantLinkStatus;
(function (MerchantLinkStatus) {
    MerchantLinkStatus["INVALID_MERCHANT_LINK_STATUS"] = "INVALID_MERCHANT_LINK_STATUS";
    /**
     * LINKING_NOT_AVAILABLE - Merchant linking not available for this merchant.
     */
    MerchantLinkStatus["LINKING_NOT_AVAILABLE"] = "LINKING_NOT_AVAILABLE";
    /**
     * RELINKING_REQUIRED - Relinking is required due to card expiration or disablement.
     */
    MerchantLinkStatus["RELINKING_REQUIRED"] = "RELINKING_REQUIRED";
    /**
     * NOT_ENROLLED - Merchant linking is available but not used.
     */
    MerchantLinkStatus["NOT_ENROLLED"] = "NOT_ENROLLED";
    MerchantLinkStatus["ENROLLED"] = "ENROLLED";
    MerchantLinkStatus["ENROLLING"] = "ENROLLING";
    MerchantLinkStatus["CREDENTIALS"] = "CREDENTIALS";
    MerchantLinkStatus["OTP"] = "OTP";
    MerchantLinkStatus["APPROVAL"] = "APPROVAL";
    MerchantLinkStatus["QUESTIONS"] = "QUESTIONS";
    MerchantLinkStatus["FAILED"] = "FAILED";
    MerchantLinkStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(MerchantLinkStatus || (exports.MerchantLinkStatus = MerchantLinkStatus = {}));
function merchantLinkStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_MERCHANT_LINK_STATUS':
            return MerchantLinkStatus.INVALID_MERCHANT_LINK_STATUS;
        case 1:
        case 'LINKING_NOT_AVAILABLE':
            return MerchantLinkStatus.LINKING_NOT_AVAILABLE;
        case 2:
        case 'RELINKING_REQUIRED':
            return MerchantLinkStatus.RELINKING_REQUIRED;
        case 3:
        case 'NOT_ENROLLED':
            return MerchantLinkStatus.NOT_ENROLLED;
        case 4:
        case 'ENROLLED':
            return MerchantLinkStatus.ENROLLED;
        case 5:
        case 'ENROLLING':
            return MerchantLinkStatus.ENROLLING;
        case 6:
        case 'CREDENTIALS':
            return MerchantLinkStatus.CREDENTIALS;
        case 7:
        case 'OTP':
            return MerchantLinkStatus.OTP;
        case 8:
        case 'APPROVAL':
            return MerchantLinkStatus.APPROVAL;
        case 9:
        case 'QUESTIONS':
            return MerchantLinkStatus.QUESTIONS;
        case 10:
        case 'FAILED':
            return MerchantLinkStatus.FAILED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return MerchantLinkStatus.UNRECOGNIZED;
    }
}
exports.merchantLinkStatusFromJSON = merchantLinkStatusFromJSON;
function merchantLinkStatusToJSON(object) {
    switch (object) {
        case MerchantLinkStatus.INVALID_MERCHANT_LINK_STATUS:
            return 'INVALID_MERCHANT_LINK_STATUS';
        case MerchantLinkStatus.LINKING_NOT_AVAILABLE:
            return 'LINKING_NOT_AVAILABLE';
        case MerchantLinkStatus.RELINKING_REQUIRED:
            return 'RELINKING_REQUIRED';
        case MerchantLinkStatus.NOT_ENROLLED:
            return 'NOT_ENROLLED';
        case MerchantLinkStatus.ENROLLED:
            return 'ENROLLED';
        case MerchantLinkStatus.ENROLLING:
            return 'ENROLLING';
        case MerchantLinkStatus.CREDENTIALS:
            return 'CREDENTIALS';
        case MerchantLinkStatus.OTP:
            return 'OTP';
        case MerchantLinkStatus.APPROVAL:
            return 'APPROVAL';
        case MerchantLinkStatus.QUESTIONS:
            return 'QUESTIONS';
        case MerchantLinkStatus.FAILED:
            return 'FAILED';
        case MerchantLinkStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.merchantLinkStatusToJSON = merchantLinkStatusToJSON;
//# sourceMappingURL=merchant-link-status.js.map